<template>
  <div>
    <div class="bg-slate-100 min-h-screen">
      <div>
        <router-view></router-view>
      </div>
    </div>
    <FloatingNavbarMenu />
  </div>
</template>

<script>
  import FloatingNavbarMenu from "@/components/FloatingNavbarMenu.vue";

  export default {
    components: {
      FloatingNavbarMenu
    }
  };
</script>
